"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogSection = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var BlogSection = /** @class */function (_super) {
  __extends(BlogSection, _super);
  function BlogSection() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BlogSection.prototype.render = function () {
    var _this = this;
    var _a;
    var gridColClassName = "gap-y-6 grid ";
    if (this.props.gridColClassName) gridColClassName += "".concat(this.props.gridColClassName);else gridColClassName += "sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 lg:gap-x-8";
    return react_1.default.createElement("div", {
      className: "relative mx-auto max-w-7xl"
    }, react_1.default.createElement("div", {
      className: gridColClassName
    }, (_a = this.props.postList) === null || _a === void 0 ? void 0 : _a.map(function (post) {
      var _a, _b, _c, _d, _e, _f;
      return react_1.default.createElement("div", {
        key: post.title,
        className: "flex flex-col overflow-hidden rounded-lg shadow-lg ".concat(post.href ? "cursor-pointer" : ""),
        onClick: function (event) {
          if (_this.props.onClickData && post.href) {
            _this.props.onClickData(post.href);
          }
          event.preventDefault();
        }
      }, react_1.default.createElement("div", {
        className: "flex items-center justify-center flex-shrink-0 relative"
      }, react_1.default.createElement("img", {
        className: "h-48 w-full              \n                    ".concat(_this.props.imgContain ? "object-contain" : "object-cover", "\n                    "),
        src: post.imageUrl,
        alt: ""
      }), post.imageContent && react_1.default.createElement("div", {
        className: "absolute"
      }, post.imageContent)), post.title && post.description && react_1.default.createElement("div", {
        className: "flex flex-1 flex-col justify-between bg-white p-6"
      }, react_1.default.createElement("div", {
        className: "flex-1"
      }, react_1.default.createElement("p", {
        className: "text-sm font-medium text-indigo-600"
      }, (_a = post.category) === null || _a === void 0 ? void 0 : _a.name), react_1.default.createElement("div", {
        className: "mt-2 block"
      }, react_1.default.createElement("p", {
        className: "text-xl font-semibold text-gray-900"
      }, (_b = post.title) !== null && _b !== void 0 ? _b : ""), react_1.default.createElement("p", {
        className: "mt-3 text-base text-gray-500"
      }, (_c = post.description) !== null && _c !== void 0 ? _c : ""), post.extra && post.extra)), post.author && react_1.default.createElement("div", {
        className: "mt-6 flex items-center"
      }, react_1.default.createElement("div", {
        className: "flex-shrink-0"
      }, react_1.default.createElement("span", {
        className: "sr-only"
      }, (_d = post.author) === null || _d === void 0 ? void 0 : _d.name), react_1.default.createElement("img", {
        className: "h-10 w-10 rounded-full",
        src: (_e = post.author) === null || _e === void 0 ? void 0 : _e.imageUrl,
        alt: ""
      })), react_1.default.createElement("div", {
        className: "ml-3"
      }, react_1.default.createElement("p", {
        className: "text-sm font-medium text-gray-900"
      }, (_f = post.author) === null || _f === void 0 ? void 0 : _f.name), react_1.default.createElement("div", {
        className: "flex space-x-1 text-sm text-gray-500"
      }, react_1.default.createElement("time", {
        dateTime: post.dateTime
      }, post.date), react_1.default.createElement("span", {
        "aria-hidden": "true"
      }, "\u00B7"), react_1.default.createElement("span", null, post.readingTime, " read"))))));
    })));
  };
  return BlogSection;
}(react_1.Component);
exports.BlogSection = BlogSection;